/* eslint-disable react/no-children-prop */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'underscore';

const propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string,
    ]),
    className: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object,
        PropTypes.string,
    ]),
    componentClass: PropTypes.oneOfType([
        PropTypes.any,
        PropTypes.string,
        PropTypes.element,
        PropTypes.object,
    ]),
};

const defaultProps = {
    componentClass: 'div',
    children: [],
    className: [],
};

/**
 * The top level Yurstrap component
 */
class Abstrap extends Component {

    /**
     * Transform the results of the this.getClassNameSchema method to a valid className prop
     * @returns {string} A valid className prop
     */
    getClassName() {
        return classNames(this.getClassNameSchema());
    }

    /**
     * Return an array of the multiple classNames
     * @return {array} An array that will be parsed by the classnames module
     */
    getClassNameSchema() {
        const { className } = this.props;
        return [className];
    }

    /**
     * Filter the non-HTML (basically the propTypes) props
     * @param {object} The propTypes of the children component
     * @return {object} The cleaned props
     */
    filterProps() {
        const omitedProps = Object.keys(this.constructor.propTypes);
        return _.omit(this.props, omitedProps);
    }

    renderChildren() {
        const { children } = this.props;
        return children;
    }

    render() {
        return (
            <this.props.componentClass
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...this.filterProps(propTypes)}
                className={this.getClassName()}
                children={this.renderChildren()}
            />
        );
    }

}

Abstrap.propTypes = propTypes;

Abstrap.defaultProps = defaultProps;

export default Abstrap;
